import { Button } from "@mui/material";
import styled from "styled-components";

export const AcessarButton = styled(Button)`
    /* @media (max-width: 768px) {
        width: 50vw !important;
    } */
`